const storeToken = (value) => {
  if (value) {
    localStorage.setItem("access", JSON.stringify(value.access));
    localStorage.setItem("refresh", JSON.stringify(value.refresh));
  }
}
const storeResponse = (value) => {
  if (value) {
      localStorage.setItem('user_id', value.user_id)
      localStorage.setItem('name', value.name)

  }
}
const getToken = () => {
  let access_token = localStorage.getItem('access')
  let refresh_token = localStorage.getItem('refresh')
  return { access_token, refresh_token }
}

const removeToken = () => {
  localStorage.removeItem('access')
  localStorage.removeItem('refresh')
  localStorage.removeItem('name')
  localStorage.removeItem('user_id')

}

export { storeToken, getToken, removeToken ,storeResponse}